"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Language = require("./Language");

Object.keys(_Language).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Language[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Language[key];
    }
  });
});

var _Locale = require("./Locale");

Object.keys(_Locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Locale[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Locale[key];
    }
  });
});

var _Translate = require("./Translate");

Object.keys(_Translate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Translate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Translate[key];
    }
  });
});

var _NumberFormat = require("./NumberFormat");

Object.keys(_NumberFormat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NumberFormat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NumberFormat[key];
    }
  });
});

var _DateTimeFormat = require("./DateTimeFormat");

Object.keys(_DateTimeFormat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DateTimeFormat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DateTimeFormat[key];
    }
  });
});